"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import Icon, {ICON_SIZES} from "@/components/library/Icon";

// PPTX cannot be rendered in the browser without shipping a large slide
// library. We previously embedded Microsoft's Office Online viewer, but that
// routes the signed download URL (and the document Microsoft fetches with it)
// through a third-party subprocessor. Fall back to a download card until we
// have a sanctioned server-side preview path.
const InlinePptxPreview: React.FC<{fileName: string}> = ({fileName}) => {
   const {t} = useTranslation("ask");
   return (
      <div className="flex flex-col items-center justify-center h-full gap-3 p-6 text-center">
         <Icon icon="file-powerpoint" size={ICON_SIZES.XXL} className="text-400" />
         <p className="text-sm text-700">{fileName}</p>
         <p className="text-xs text-500">{t("preview.downloadToView")}</p>
      </div>
   );
};

export default InlinePptxPreview;
